import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BarChart3, CheckCircle2 } from "lucide-react";

export default function PollWidget({ articleId = null }) {
  const [poll, setPoll] = useState(null);
  const [voted, setVoted] = useState(null);

  const load = async () => {
    try {
      if (articleId) {
        const r = await api.get("/polls", { params: { article_id: articleId } });
        setPoll((r.data || [])[0] || null);
      } else {
        const r = await api.get("/polls/active");
        setPoll(r.data || null);
      }
    } catch (err) { console.warn("[popu]", err); }
  };

  useEffect(() => {
    load();
    const v = localStorage.getItem(`popu-poll-voted`);
    if (v) {
      try { setVoted(JSON.parse(v)); } catch (err) { console.warn("[popu]", err); }
    }
  }, [articleId]);

  if (!poll) return null;

  const totalVotes = (poll.options || []).reduce((acc, o) => acc + (o.votes || 0), 0);
  const myVote = voted?.[poll.id];

  const vote = async (optId) => {
    if (myVote) return;
    try {
      const r = await api.post(`/polls/${poll.id}/vote`, { option_id: optId });
      setPoll(r.data);
      const next = { ...(voted || {}), [poll.id]: optId };
      setVoted(next);
      localStorage.setItem("popu-poll-voted", JSON.stringify(next));
    } catch (err) { console.warn("[popu]", err); }
  };

  return (
    <div className="rounded-sm border p-5" style={{ borderColor: "var(--border)", background: "var(--surface)" }} data-testid="poll-widget">
      <div className="flex items-center gap-2 mb-3 overline">
        <BarChart3 size={14} className="accent-text" /> ENCUESTA POPU
      </div>
      <h3 className="font-headline uppercase text-lg leading-tight mb-4">{poll.question}</h3>
      <ul className="space-y-2">
        {(poll.options || []).map((o) => {
          const pct = totalVotes ? Math.round((o.votes / totalVotes) * 100) : 0;
          const isMine = myVote === o.id;
          return (
            <li key={o.id}>
              <button
                onClick={() => vote(o.id)}
                disabled={!!myVote}
                data-testid={`poll-option-${o.id}`}
                className="w-full text-left relative rounded-sm border overflow-hidden transition disabled:cursor-default"
                style={{ borderColor: isMine ? "var(--accent)" : "var(--border)" }}
              >
                {myVote && (
                  <div
                    className="absolute inset-y-0 left-0"
                    style={{
                      width: `${pct}%`,
                      background: isMine ? "rgba(var(--accent-rgb), 0.18)" : "rgba(0,0,0,0.06)",
                      transition: "width 0.6s ease",
                    }}
                  />
                )}
                <div className="relative px-3 py-2.5 flex items-center justify-between gap-3 text-sm">
                  <span className="flex items-center gap-2">
                    {isMine && <CheckCircle2 size={14} className="accent-text" />}
                    <span style={{ color: "var(--text)" }}>{o.text}</span>
                  </span>
                  {myVote && <span className="text-xs font-bold" style={{ color: "var(--text-muted)" }}>{pct}%</span>}
                </div>
              </button>
            </li>
          );
        })}
      </ul>
      {myVote && (
        <p className="text-xs mt-3" style={{ color: "var(--text-muted)" }}>{totalVotes} votos</p>
      )}
    </div>
  );
}
